/**
 * @generated SignedSource<<f9c2bb61c5e0420e596573a4a9a04a03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuditEventType = "AGENT_TOKEN_CREATED" | "AGENT_TOKEN_REVOKED" | "AGENT_TOKEN_UPDATED" | "API_ACCESS_TOKEN_CREATED" | "API_ACCESS_TOKEN_DELETED" | "API_ACCESS_TOKEN_ORGANIZATION_ACCESS_REVOKED" | "API_ACCESS_TOKEN_UPDATED" | "AUTHORIZATION_CREATED" | "AUTHORIZATION_DELETED" | "CLUSTER_CREATED" | "CLUSTER_DELETED" | "CLUSTER_PERMISSION_CREATED" | "CLUSTER_PERMISSION_DELETED" | "CLUSTER_QUEUE_CREATED" | "CLUSTER_QUEUE_DELETED" | "CLUSTER_QUEUE_TOKEN_CREATED" | "CLUSTER_QUEUE_TOKEN_DELETED" | "CLUSTER_QUEUE_TOKEN_UPDATED" | "CLUSTER_QUEUE_UPDATED" | "CLUSTER_TOKEN_CREATED" | "CLUSTER_TOKEN_DELETED" | "CLUSTER_TOKEN_UPDATED" | "CLUSTER_UPDATED" | "JOB_TERMINAL_SESSION_STARTED" | "NOTIFICATION_SERVICE_BROKEN" | "NOTIFICATION_SERVICE_CREATED" | "NOTIFICATION_SERVICE_DELETED" | "NOTIFICATION_SERVICE_DISABLED" | "NOTIFICATION_SERVICE_ENABLED" | "NOTIFICATION_SERVICE_UPDATED" | "ORGANIZATION_BANNER_CREATED" | "ORGANIZATION_BANNER_DELETED" | "ORGANIZATION_BANNER_UPDATED" | "ORGANIZATION_BUILD_EXPORT_UPDATED" | "ORGANIZATION_CREATED" | "ORGANIZATION_DELETED" | "ORGANIZATION_IMPERSONATION_REQUEST_APPROVED" | "ORGANIZATION_IMPERSONATION_REQUEST_REVOKED" | "ORGANIZATION_INVITATION_ACCEPTED" | "ORGANIZATION_INVITATION_CREATED" | "ORGANIZATION_INVITATION_RESENT" | "ORGANIZATION_INVITATION_REVOKED" | "ORGANIZATION_MEMBER_CREATED" | "ORGANIZATION_MEMBER_DELETED" | "ORGANIZATION_MEMBER_UPDATED" | "ORGANIZATION_TEAMS_DISABLED" | "ORGANIZATION_TEAMS_ENABLED" | "ORGANIZATION_UPDATED" | "PIPELINE_CREATED" | "PIPELINE_DELETED" | "PIPELINE_SCHEDULE_CREATED" | "PIPELINE_SCHEDULE_DELETED" | "PIPELINE_SCHEDULE_UPDATED" | "PIPELINE_TEMPLATE_CREATED" | "PIPELINE_TEMPLATE_DELETED" | "PIPELINE_TEMPLATE_UPDATED" | "PIPELINE_UPDATED" | "PIPELINE_VISIBILITY_CHANGED" | "PIPELINE_WEBHOOK_URL_ROTATED" | "REGISTRY_CREATED" | "REGISTRY_DELETED" | "REGISTRY_TOKEN_CREATED" | "REGISTRY_TOKEN_DELETED" | "REGISTRY_TOKEN_UPDATED" | "REGISTRY_UPDATED" | "SCM_PIPELINE_SETTINGS_CREATED" | "SCM_PIPELINE_SETTINGS_DELETED" | "SCM_PIPELINE_SETTINGS_UPDATED" | "SCM_REPOSITORY_HOST_CREATED" | "SCM_REPOSITORY_HOST_DESTROYED" | "SCM_REPOSITORY_HOST_UPDATED" | "SCM_SERVICE_CREATED" | "SCM_SERVICE_DELETED" | "SCM_SERVICE_UPDATED" | "SECRET_CREATED" | "SECRET_DELETED" | "SECRET_QUERIED" | "SECRET_READ" | "SECRET_UPDATED" | "SSO_PROVIDER_CREATED" | "SSO_PROVIDER_DELETED" | "SSO_PROVIDER_DISABLED" | "SSO_PROVIDER_ENABLED" | "SSO_PROVIDER_UPDATED" | "STORAGE_CREATED" | "SUBSCRIPTION_PLAN_ADDED" | "SUBSCRIPTION_PLAN_CHANGED" | "SUBSCRIPTION_PLAN_CHANGE_SCHEDULED" | "SUITE_API_TOKEN_REGENERATED" | "SUITE_CREATED" | "SUITE_DELETED" | "SUITE_MONITOR_CREATED" | "SUITE_MONITOR_DELETED" | "SUITE_MONITOR_UPDATED" | "SUITE_UPDATED" | "SUITE_VISIBILITY_CHANGED" | "TEAM_CREATED" | "TEAM_DELETED" | "TEAM_MEMBER_CREATED" | "TEAM_MEMBER_DELETED" | "TEAM_MEMBER_UPDATED" | "TEAM_PIPELINE_CREATED" | "TEAM_PIPELINE_DELETED" | "TEAM_PIPELINE_UPDATED" | "TEAM_REGISTRY_CREATED" | "TEAM_REGISTRY_DELETED" | "TEAM_REGISTRY_UPDATED" | "TEAM_SUITE_CREATED" | "TEAM_SUITE_DELETED" | "TEAM_SUITE_UPDATED" | "TEAM_UPDATED" | "USER_API_ACCESS_TOKEN_ORGANIZATION_ACCESS_ADDED" | "USER_API_ACCESS_TOKEN_ORGANIZATION_ACCESS_REMOVED" | "USER_EMAIL_CREATED" | "USER_EMAIL_DELETED" | "USER_EMAIL_MARKED_PRIMARY" | "USER_EMAIL_VERIFIED" | "USER_IMPERSONATED" | "USER_PASSWORD_RESET" | "USER_PASSWORD_RESET_REQUESTED" | "USER_TOTP_ACTIVATED" | "USER_TOTP_CREATED" | "USER_TOTP_DELETED" | "USER_UPDATED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type eventSection_auditEvent$data = {
  readonly data: any | null;
  readonly occurredAt: any;
  readonly type: AuditEventType;
  readonly uuid: string;
  readonly " $fragmentType": "eventSection_auditEvent";
};
export type eventSection_auditEvent$key = {
  readonly " $data"?: eventSection_auditEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventSection_auditEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventSection_auditEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occurredAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "type": "AuditEvent",
  "abstractKey": null
};

(node as any).hash = "f981ef37a61efb4f55233c73fdf6dde5";

export default node;
